import { number } from "zod";
import { PaginationDetails } from "./api_request";

export interface FacilityListProps {
  _id: string;
  email: string;
  createdAt: string;
  isVerified: boolean;
  updatedAt: string;
  avatar: string;
  facility_size: string;
  facility_type: string;
  freeze: boolean;
  isDeleted: boolean;
  isSignupCompleted: boolean;
  level: number;
  name: string;
  password: string;
  role: string;
  suspended: boolean;
  tag: {
    note: string;
    status: boolean;
    taggedAt: any;
    admin: any;
  };
  type: string;
  lastLogin: string;
  updated_at: string;
}

export interface HospitalContentProps {
  facilityList: FacilityListProps[];
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
  stats: FacilityStatsProps;
}

export interface HospitalTableProps {
  data: FacilityListProps[];
  loading: boolean;
}

export interface FacilityListProps {
  avatar: string;
  created_at: string;
  email: string;
  facility_size: string;
  facility_type: string;
  freeze: boolean;
  isDeleted: boolean;
  isSignupCompleted: boolean;
  isVerified: boolean;
  lastLogin: string;
  level: number;
  name: string;
  password: string;
  role: string;
  suspended: boolean;
  tag: { note: string; status: boolean; taggedAt: any; admin: any };
  type: string;
  updated_at: string;
  _id: string;
  specialties: string;
  reg_no: string;
  state: string;
  verification: string;

}

export const FacilityListPropsDummy = {
  avatar: "",
  created_at: "",
  createdAt: "",
  email: "",
  facility_size: "",
  facility_type: "",
  freeze: false,
  isDeleted: false,
  isSignupCompleted: false,
  isVerified: false,
  lastLogin: "",
  level: 0,
  name: "",
  password: "",
  role: "",
  suspended: false,
  tag: { note: "", status: false, taggedAt: null, admin: null },
  type: "",
  updated_at: "",
  updatedAt: "",
  _id: "",
  specialties: "",
  reg_no: "",
  state: "",
  verification: "",
};

export interface FacilityEmploymentProps {
  application: string;
  created_at: string;
  employment_details: {
    benefits: string;
    end_date: any;
    positon: string;
    salary: number;
    start_date: string;
  };
  facility: string;
  facility_info: { name: string };
  job: string;
  job_info: {
    contract_duration: string;
    department: string;
    employment_type: string;
    job_title: string;
    job_type: string;
    work_location: string;
    work_type: string;
  };
  medic: string;
  medic_info: {
    medic_type: string;
    name: string;
  };
  note: string;
  performance_review: {
    comment: string;
    date: string;
    rating: string;
  };
  status: string;
  updated_at: string;
  _id: string;
}

export interface FacilityJobsProps {
  additional_info: string;
  application_deadline: string;
  contract_duration: string;
  created_at: string;
  department: string;
  employment_type: string;
  experience_level: string;
  facility: string;
  facility_info: { name: string; avatar: string };
  how_to_apply: string;
  job_description: string;
  job_title: string;
  job_type: string;
  qualifications: string;
  required_documents: string;
  salary_range: string;
  stats: {
    number_of_applicants: number;
    pending_reviews: number;
    shorlisted_candidates: number;
    upcoming_interviews: number;
    rejected_candidates: number;
  };
  status: string;
  updated_at: string;
  work_location: string;
  work_schedule: string;
  work_type: string;
  _id: string;
}

export interface FacilityEmploymentAnalytics {
  employmentTypeCount: any;
  jobTitleCount: any;
  jobTypeCount: any;
  maxSalary: number;
  minSalary: number;
  statusCount: any;
  totalEmployees: number;
  totalSalary: number;
  workTypeCount: any;
}

export const FacilityEmploymentAnalyticsDummy = {
  employmentTypeCount: {},
  jobTitleCount: {},
  jobTypeCount: {},
  maxSalary: 0,
  minSalary: 0,
  statusCount: {},
  totalEmployees: 0,
  totalSalary: 0,
  workTypeCount: {},
};

export interface FacilityStatsProps {
  activeDocument: number;
  inactiveDocument: number;
  totalFacility: number;
}

export interface FacilityJobStatsProps {
  avgApplicants: number;
  employmentTypeCount: any;
  jobTypeCount: any;
  statusCount: any;
  totalApplicants: number;
  totalJobs: number;
  totalPendingReviews: number;
  totalShortlisted: number;
  totalUpcomingInterviews: number;
  workLocationCount: any;
  workTypeCount: any;
}

export interface FacilityEmployeeProps {
  employment: any[];
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>
  stats: FacilityEmploymentAnalytics;
  pagination_state: PaginationDetails;
  setPagination_state: React.Dispatch<React.SetStateAction<PaginationDetails>>;
  handleOpenSelectedModalData: (e: any) => void;
}
export interface FacilityJobsDetailsProps {
  jobs_list: FacilityJobsProps[];
  loading: boolean;
  stats: FacilityJobStatsProps;
  setFilterData: React.Dispatch<React.SetStateAction<string>>
  pagination_state: PaginationDetails;
  setPagination_state: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}
